import { OrganisationTypeConstants } from "../../../../constants";
import { AuditChangesPanelTemplate } from "../../../../templates";
import { useAuth } from "../../../../useAuth";
import { Column, CursorDataGrid, Row } from "../../../../widget";
import { useAuditHistory } from "./useAuditHistory";

const AuditHistory = (): JSX.Element => {
  const { currentUserType } = useAuth();
  const {
    columns,
    defaultSortingCriteria,
    dataIsLoading,
    auditDataUuid,
    auditDataChange,
    showAuditChangesPanel,
    exportFileName,
    setShowAuditChangesPanel,
    onChange,
  } = useAuditHistory();
  const isAssetManager = currentUserType === OrganisationTypeConstants.ASSET_MANAGER;
  return (
    <div className={`SettingsAuditHistoryTab${isAssetManager ? " TemplateTabCard" : ""}`}>
      <Row spacingV="ll">
        <Column span={9}>
          <h2 style={{ margin: 0 }}>Audit history</h2>
        </Column>
      </Row>
      <CursorDataGrid
        columns={columns}
        clientSide={false}
        filterable
        onChange={onChange}
        data={[]}
        noDataMessage="No audit data to display"
        dataIsLoading={dataIsLoading}
        defaultSortingCriteria={defaultSortingCriteria}
        variant={isAssetManager ? "seed" : "default"}
        exportable
        exportFileName={exportFileName}
      />
      {auditDataUuid && (
        <AuditChangesPanelTemplate
          auditDataUuid={auditDataUuid}
          auditDataChange={auditDataChange}
          show={showAuditChangesPanel}
          onClose={() => setShowAuditChangesPanel(false)}
        />
      )}
    </div>
  );
};

export default AuditHistory;
